export default __webpack_public_path__ + "static/media/button-edit.a1892ea7.svg";